import React, { FC } from 'react';
import Image from 'next/image';
import AppUpsellCta from './AppUpsellCta';
import Icon from '@components/atoms/icon';
import { BodyRegularBold } from '@components/atoms/typography';

type AppUpsellBannerProps = {
  storeUrl: string;
  ctaLabel: string;
  onCtaClick: () => void;
  onClose: () => void;
  /** Lifts the banner above the app's BottomTabNav in webview. */
  isAppView: boolean;
};

const AppUpsellBanner: FC<AppUpsellBannerProps> = ({
  storeUrl,
  ctaLabel,
  onCtaClick,
  onClose,
  isAppView
}) => (
  <div
    data-cy="app-upsell-banner"
    className={`fixed inset-x-2 z-[999] flex items-center gap-3 rounded-xl bg-primary-100 p-3 shadow-300 ${
      isAppView
        ? // The app's native tab bar overlaps the bottom 50px of the webview
          // (marginTop: -50 in the app's HomeTab), so 64px keeps the banner
          // clear of it with a visible gap.
          'bottom-16'
        : 'bottom-[max(0.5rem,env(safe-area-inset-bottom))]'
    }`}
  >
    <Image
      src="/images/hub-logo.svg"
      alt="Fantasy Football Hub"
      width={40}
      height={40}
      className="shrink-0 rounded-lg bg-black p-1.5"
    />
    <BodyRegularBold className="flex-1 text-primary-800">
      Try the new FFH app
    </BodyRegularBold>
    <AppUpsellCta
      storeUrl={storeUrl}
      ctaLabel={ctaLabel}
      onClick={onCtaClick}
      dataCy="app-upsell-banner-cta"
    />
    <button
      type="button"
      onClick={onClose}
      aria-label="Dismiss"
      data-cy="app-upsell-banner-close"
      className="p-1"
    >
      <Icon name="Close" className="w-5 h-5 text-neutral-800" />
    </button>
  </div>
);

export default AppUpsellBanner;
